import { createFileRoute } from '@tanstack/react-router'
import { Footprints } from 'lucide-react'
import { TraceDetailScreen } from '@/screens/investigate/SCR-020-trace-detail'

function TraceRoute() {
  const { traceId } = Route.useParams()
  return <TraceDetailScreen key={traceId} traceId={traceId} />
}

export const Route = createFileRoute('/_app/w/$ws/traces_/$traceId')({
  staticData: { screen: { id: 'SCR-020', title: 'Trace detail', group: 'Investigate', perm: 'trace.read', hidden: true, description: 'One request, step by step, with the evidence for each step.', icon: Footprints } },
  component: TraceRoute,
})
